'use strict';

import GLightbox from 'glightbox'
import Component from "../../base/Component";

export default class Glightbox extends Component {
    init() {
        GLightbox()
    }
}
